{
  "familyId": "SWW-TT-GEBIEDENDE",
  "questions": [
    {
      "id": "SWW-TT-GEBIEDENDE-001",
      "familyId": "SWW-TT-GEBIEDENDE",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_gebiedende_wijs",
      "questionType": "multiple_choice",
      "question": "Wat is de gebiedende wijs van 'lopen'?",
      "options": ["Loop!", "Loopt!", "Lopen!", "Liep!"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gebiedende wijs",
            "content": "De gebiedende wijs = de stam van het werkwoord. Stam = hele werkwoord zonder -en. Lopen → stam = loop. Gebiedende wijs: Loop!",
            "icon": "lightbulb"
          }
        }
,
        {
          "type": "verbTable",
          "showWhen": "wrong",
          "data": { "verb": "lopen", "forms": { "stam": "loop", "tt_ik": "loop", "tt_jij": "loopt", "tt_hij": "loopt", "vt_ik": "liep", "vt_wij": "liepen", "vd": "gelopen" }, "label": "Lopen: gebiedende wijs = stam (loop!)" }
        }
      ],
      "conceptId": "gebiedende_basis",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.gebiedende-met-t", "label": "Gebiedende wijs met -t geschreven (jij/hij-vorm gebruikt)", "optionIndex": 1 },
          { "id": "sww.infinitive-instead-of-stem", "label": "Hele werkwoord gebruikt i.p.v. stam", "optionIndex": 2 },
          { "id": "sww.tt-vt-verwarring", "label": "Verleden tijd verward met tegenwoordige tijd", "optionIndex": 3 }
        ]
      },
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De gebiedende wijs is de stam van het werkwoord. Lopen → stam = loop (zonder -en). Dus: Loop!",
        "solutionSteps": [
          "Heel werkwoord: lopen",
          "Stam: lopen − en = loop",
          "Gebiedende wijs = stam: Loop!"
        ],
        "distractorExplanations": {
          "0": "Goed! De gebiedende wijs van 'lopen' is 'Loop!' (= de stam).",
          "1": "'Loopt' is de hij/zij-vorm (derde persoon). De gebiedende wijs heeft geen -t: Loop!, niet Loopt!",
          "2": "'Lopen' is het hele werkwoord (infinitief). De gebiedende wijs is de stam: Loop!",
          "3": "'Liep' is de verleden tijd. De gebiedende wijs is altijd in de tegenwoordige tijd: Loop!"
        }
      }
    },
    {
      "id": "SWW-TT-GEBIEDENDE-002",
      "familyId": "SWW-TT-GEBIEDENDE",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_gebiedende_wijs",
      "questionType": "multiple_choice",
      "question": "Welke zin staat in de gebiedende wijs?",
      "options": ["Ruim je kamer op!", "Hij ruimt zijn kamer op.", "Zij ruimen de kamer op.", "Wij hebben opgeruimd."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gebiedende wijs herkennen",
            "content": "De gebiedende wijs is een bevel of verzoek. Je herkent het aan: (1) het werkwoord staat vooraan, (2) er is geen onderwerp (of 'je/jij' erna), (3) vaak een uitroepteken.",
            "icon": "lightbulb"
          }
        }
,
        {
          "type": "verbTable",
          "showWhen": "wrong",
          "data": { "verb": "opruimen", "forms": { "stam": "ruim", "tt_ik": "ruim op", "tt_jij": "ruimt op", "tt_hij": "ruimt op", "vt_ik": "ruimde op", "vt_wij": "ruimden op", "vd": "opgeruimd" }, "label": "Opruimen: bevel = stam vooraan (Ruim ... op!)" }
        }
      ],
      "conceptId": "gebiedende_herkennen",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.gebiedende-niet-herkend", "label": "Gewone mededeling aangezien voor bevel", "optionIndex": 1 },
          { "id": "sww.gebiedende-niet-herkend", "label": "Meervoudsvorm aangezien voor bevel", "optionIndex": 2 },
          { "id": "sww.gebiedende-niet-herkend", "label": "Voltooide tijd aangezien voor bevel", "optionIndex": 3 }
        ]
      },
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Ruim je kamer op!' is een bevel → gebiedende wijs. Het werkwoord 'ruim' (stam) staat vooraan, gevolgd door een opdracht.",
        "solutionSteps": [
          "'Ruim je kamer op!' = bevel/opdracht",
          "Werkwoord (stam) staat vooraan",
          "Uitroepteken → gebiedende wijs"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Ruim je kamer op!' is een bevel in de gebiedende wijs.",
          "1": "'Hij ruimt zijn kamer op' is een gewone mededeling (indicatief), geen bevel.",
          "2": "'Zij ruimen de kamer op' is een mededeling over meerdere personen, geen bevel.",
          "3": "'Wij hebben opgeruimd' is een voltooide tijd, geen gebiedende wijs."
        }
      }
    },
    {
      "id": "SWW-TT-GEBIEDENDE-003",
      "familyId": "SWW-TT-GEBIEDENDE",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_gebiedende_wijs",
      "questionType": "multiple_choice",
      "question": "Wat is de gebiedende wijs van 'worden'?",
      "options": ["Word!", "Wordt!", "Worden!", "Werd!"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gebiedende wijs: geen -t",
            "content": "De gebiedende wijs = de stam, ZONDER -t. Worden → stam = word. Gebiedende wijs: Word! (niet Wordt!). Dit is een veelgemaakte fout.",
            "icon": "lightbulb"
          }
        }
,
        {
          "type": "verbTable",
          "showWhen": "wrong",
          "data": { "verb": "worden", "forms": { "stam": "word", "tt_ik": "word", "tt_jij": "wordt", "tt_hij": "wordt", "vt_ik": "werd", "vt_wij": "werden", "vd": "geworden" }, "label": "Worden: stam = word (gebiedende wijs zonder -t)" }
        }
      ],
      "conceptId": "gebiedende_geen_t",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Worden → stam = word. De gebiedende wijs is altijd de stam ZONDER -t. Dus: Word!, niet Wordt! Dit is een veelgemaakte fout bij d-stam werkwoorden.",
        "solutionSteps": [
          "Worden → stam = word",
          "Gebiedende wijs = stam (zonder -t)",
          "Word! (niet Wordt!)"
        ],
        "distractorExplanations": {
          "0": "Goed! De gebiedende wijs van 'worden' is 'Word!' (stam, zonder -t).",
          "1": "'Wordt' is de jij/hij-vorm. De gebiedende wijs heeft NOOIT een -t: Word!, niet Wordt!",
          "2": "'Worden' is het hele werkwoord. De gebiedende wijs is de stam: Word!",
          "3": "'Werd' is de verleden tijd. De gebiedende wijs is altijd tegenwoordige tijd: Word!"
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.gebiedende-met-t", "label": "Gebiedende wijs met -t geschreven (jij/hij-vorm gebruikt)", "optionIndex": 1 },
          { "id": "sww.infinitive-instead-of-stem", "label": "Hele werkwoord gebruikt i.p.v. stam", "optionIndex": 2 },
          { "id": "sww.tt-vt-verwarring", "label": "Verleden tijd verward met gebiedende wijs", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-TT-GEBIEDENDE-004",
      "familyId": "SWW-TT-GEBIEDENDE",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_gebiedende_wijs",
      "questionType": "multiple_choice",
      "question": "Welke gebiedende wijs is FOUT geschreven?",
      "options": ["Vindt het leuk!", "Geef het door!", "Kom hier!", "Wacht even!"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gebiedende wijs: altijd stam",
            "content": "De gebiedende wijs = stam, NOOIT met -t. Vinden → stam = vind. Gebiedende wijs: Vind! (niet Vindt!). De -t hoort er niet bij.",
            "icon": "lightbulb"
          }
        }
,
        {
          "type": "verbTable",
          "showWhen": "wrong",
          "data": { "verb": "vinden", "forms": { "stam": "vind", "tt_ik": "vind", "tt_jij": "vindt", "tt_hij": "vindt", "vt_ik": "vond", "vt_wij": "vonden", "vd": "gevonden" }, "label": "Vinden: stam = vind (gebiedende wijs zonder -t)" }
        }
      ],
      "conceptId": "gebiedende_fout_detectie",
      "variantIndex": 4,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.67,
      "feedback": {
        "explanationText": "'Vindt het leuk!' is fout. Vinden → stam = vind. De gebiedende wijs heeft NOOIT een -t. Correct: 'Vind het leuk!' De andere drie zijn correct: Geef!, Kom!, Wacht!",
        "solutionSteps": [
          "Vinden → stam = vind",
          "Gebiedende wijs = stam zonder -t",
          "'Vindt' is FOUT → moet 'Vind' zijn",
          "Geef, Kom, Wacht zijn correct (stam)"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Vindt het leuk!' is fout. Het moet 'Vind het leuk!' zijn (stam, zonder -t).",
          "1": "'Geef het door!' is correct. Geven → stam = geef.",
          "2": "'Kom hier!' is correct. Komen → stam = kom.",
          "3": "'Wacht even!' is correct. Wachten → stam = wacht."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.correct-form-marked-wrong", "label": "Correcte gebiedende wijs aangezien als fout", "optionIndex": 1 },
          { "id": "sww.correct-form-marked-wrong", "label": "Correcte gebiedende wijs aangezien als fout", "optionIndex": 2 },
          { "id": "sww.correct-form-marked-wrong", "label": "Correcte gebiedende wijs aangezien als fout", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-TT-GEBIEDENDE-005",
      "familyId": "SWW-TT-GEBIEDENDE",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_gebiedende_wijs",
      "questionType": "fill_in",
      "question": "Maak de gebiedende wijs van 'rijden'. Typ alleen het werkwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["Rijd", "rijd", "Rijd!", "rijd!"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stam bepalen",
            "content": "Rijden → stam = rijd (zonder -en). De gebiedende wijs = stam. Let op: de d-klank blijft staan (rijd, niet rij).",
            "icon": "lightbulb"
          }
        }
,
        {
          "type": "verbTable",
          "showWhen": "wrong",
          "data": { "verb": "rijden", "forms": { "stam": "rijd", "tt_ik": "rijd", "tt_jij": "rijdt", "tt_hij": "rijdt", "vt_ik": "reed", "vt_wij": "reden", "vd": "gereden" }, "label": "Rijden: stam = rijd (de d blijft staan)" }
        }
      ],
      "conceptId": "gebiedende_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Rijden → stam = rijd. De gebiedende wijs is de stam: Rijd! Let op: de d blijft staan omdat je die hoort in 'rijden'.",
        "solutionSteps": [
          "Heel werkwoord: rijden",
          "Stam: rijden − en = rijd",
          "Gebiedende wijs = stam: Rijd!"
        ]
      }
    },
    {
      "id": "SWW-TT-GEBIEDENDE-009",
      "familyId": "SWW-TT-GEBIEDENDE",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_gebiedende_wijs",
      "questionType": "fill_in",
      "question": "Wat is de gebiedende wijs van 'zwemmen'? Typ alleen het werkwoord met een uitroepteken (bijv. Loop!).",
      "correctAnswer": "Zwem!",
      "data": {
        "acceptedAnswers": ["Zwem!", "zwem!", "Zwem", "zwem"],
        "placeholder": "gebiedende wijs...",
        "inputType": "text"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Gebiedende wijs", "content": "De gebiedende wijs = de stam van het werkwoord. Stam = hele werkwoord zonder -en. Zwemmen → stam = zwem. Gebiedende wijs: Zwem!", "icon": "lightbulb" } }
,
        {
          "type": "verbTable",
          "showWhen": "wrong",
          "data": { "verb": "zwemmen", "forms": { "stam": "zwem", "tt_ik": "zwem", "tt_jij": "zwemt", "tt_hij": "zwemt", "vt_ik": "zwom", "vt_wij": "zwommen", "vd": "gezwommen" }, "label": "Zwemmen: stam = zwem (dubbele m wordt enkel)" }
        }
      ],
      "conceptId": "gebiedende_fill_in_zwem",
      "variantIndex": 9,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De gebiedende wijs is altijd de stam van het werkwoord. Zwemmen → stam = zwem (haal -men weg, want dubbele m wordt enkel). Gebiedende wijs: Zwem!",
        "solutionSteps": [
          "Heel werkwoord: zwemmen",
          "Stam: zwemmen − en = zwem",
          "Gebiedende wijs = stam: Zwem!"
        ]
      }
    },
    {
      "id": "SWW-TT-GEBIEDENDE-010",
      "familyId": "SWW-TT-GEBIEDENDE",
      "module": "SpellingWW",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_gebiedende_wijs",
      "questionType": "fill_in",
      "question": "Wat is de gebiedende wijs van 'geven'? Typ alleen het werkwoord met een uitroepteken.",
      "correctAnswer": "Geef!",
      "data": {
        "acceptedAnswers": ["Geef!", "geef!", "Geef", "geef"],
        "placeholder": "gebiedende wijs...",
        "inputType": "text"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Gebiedende wijs", "content": "De gebiedende wijs = de stam. Geven → stam = geef (korte e wordt lange ee, v wordt f). Gebiedende wijs: Geef!", "icon": "lightbulb" } }
,
        {
          "type": "verbTable",
          "showWhen": "wrong",
          "data": { "verb": "geven", "forms": { "stam": "geef", "tt_ik": "geef", "tt_jij": "geeft", "tt_hij": "geeft", "vt_ik": "gaf", "vt_wij": "gaven", "vd": "gegeven" }, "label": "Geven: stam = geef (e → ee, v → f)" }
        }
      ],
      "conceptId": "gebiedende_fill_in_geef",
      "variantIndex": 10,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De stam van 'geven' is 'geef'. Let op twee veranderingen: 1) de korte e wordt een lange ee (open lettergreep → gesloten), 2) de v wordt een f (aan het eind van een woord). Gebiedende wijs: Geef!",
        "solutionSteps": [
          "Heel werkwoord: geven",
          "Stam: geven − en = geef (ee + f)",
          "Gebiedende wijs = stam: Geef!"
        ]
      }
    }
  ]
}